import React, { Fragment } from 'react';
import intl from 'react-intl-universal';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import MDBox from 'components/MDBox';
import iconNewSendbackLight from 'assets/images/icons/icon-homepage-new-sendback-light.svg';
import iconNewSendbackDark from 'assets/images/icons/icon-homepage-new-sendback-dark.svg';
import iconNewReceivedLight from 'assets/images/icons/icon-homepage-new-received-light.svg';
import iconNewReceivedDark from 'assets/images/icons/icon-homepage-new-received-dark.svg';
import HomeCard from '../components/HomeCard';
import {
  isCurrentUserTaskManager,
  doesUserHaveOrganizationTaskListPrivilege,
} from 'utils/privilege';

const propTypes = {
  numNewReceived: PropTypes.number.isRequired,
  numNewSendback: PropTypes.number.isRequired,
};

export const StaffOrManagerHomeDashboard = ({
  numNewReceived,
  numNewSendback,
}) => {
  const isTaskManagementPrivilege = isCurrentUserTaskManager();
  const isOrganizationTaskListPrivilege =
    doesUserHaveOrganizationTaskListPrivilege();
  return (
    <Fragment>
      {isTaskManagementPrivilege && (
        <MDBox
          display="flex"
          sx={{ flexDirection: 'column' }}
          justifyContent="center"
          alignItems="center"
          px={1.5}
          component={Link}
          to="/dashboard/task-management/task-management-regular">
          <HomeCard
            badgeContent={numNewReceived}
            imgDarkSource={iconNewReceivedDark}
            imgLightSource={iconNewReceivedLight}
            text={intl.get('home_link_new_received_issues')}
          />
        </MDBox>
      )}

      {isOrganizationTaskListPrivilege && (
        <MDBox
          display="flex"
          sx={{ flexDirection: 'column' }}
          justifyContent="center"
          alignItems="center"
          px={1}
          component={Link}
          to="/dashboard/history/sent">
          <HomeCard
            badgeContent={numNewSendback}
            imgDarkSource={iconNewSendbackDark}
            imgLightSource={iconNewSendbackLight}
            text={intl.get('home_link_new_sendback_issues')}
          />
        </MDBox>
      )}
    </Fragment>
  );
};

StaffOrManagerHomeDashboard.propTypes = propTypes;
